import { SATNDALONE_BOT } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stndAlnBtReportType: "1",
  stndAlnBtRptNvgtValue: "Chat_Rpt",
  stndAlnBtRptEditColumn: [],
  botAgnetableData : []
};

const standAloneBot = createSlice({
  name: SATNDALONE_BOT,
  initialState,
  reducers: {
    stndAlnBtReportType: (state, { payload }) => {

      state.stndAlnBtReportType = payload.stndAlnBtReportTypeValue
      switch (payload.stndAlnBtReportTypeValue) {
        case '1':
          state.stndAlnBtRptNvgtValue = "Chat_Rpt"
          break;
        case '2':
          state.stndAlnBtRptNvgtValue = "Bt_report"
      }
    },
    reportNvagiation: (state, { payload }) => {
      state.stndAlnBtRptNvgtValue = payload.stndAlnBtRptNvgtValue;
    },
    reportColumnEdit: (state, { payload }) => {
      state.stndAlnBtRptEditColumn = payload.stndAlnBtRptEditColumn;
    },
    botAgentDataTable: (state, { payload }) => {
      state.botAgnetableData = payload.botAgnetableData;
    },

  },
});
export const standAloneBotAction = standAloneBot.actions;
export default standAloneBot.reducer;
